import React from 'react';

const ValueProp = () => {
  return (
    <section className="py-20 bg-[#0b0014]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-2xl md:text-3xl lg:text-4xl text-gray-200 leading-relaxed">
            A purpose-built blockchain infrastructure.{' '}
            <span className="text-white font-medium">
              Stocks Protocol combines the speed of Stellar with the liquidity of XRPL
            </span>
            {' '}to deliver instant stock settlements, 24/7 trading, and true asset ownership.
          </p>
          
          <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-400">3-5s</div>
              <div className="text-gray-500 text-sm">Settlement Time</div>
            </div>
            <div className="w-px h-12 bg-white/10" />
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-400">$0.001</div>
              <div className="text-gray-500 text-sm">Avg. Transaction Fee</div>
            </div>
            <div className="w-px h-12 bg-white/10" />
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-400">60+</div>
              <div className="text-gray-500 text-sm">Tokenized Stocks</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProp;
